export default function NewDocInfo(){
  return(
    <div>
      New Document Info coming soon!
    </div>
  );
}